import { useRef, useMemo } from 'react';
import { useElementSize, useLoadedImage, useActivityIndicator, NoSSR, PostloadedImage } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { PlaceItemsOnImageDropzone } from './dropzone/_input.dropzone.js';
import { backgroundImageMaxHeightInPx, wrapper, canvas, inputs, background } from './organism.canvas.style.js';
import { transformInputsToRelativePositions } from './util.transform-to-relative-positions.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Canvas(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  const imageRef = useRef(null);
  const dimensions = useElementSize(imageRef, {
    axis: "vertical",
    updateState: true,
    applyTo: imageRef
  });
  const img = useLoadedImage({
    src: props.task.backgroundImageSrc
  });
  const inputs$1 = useMemo(() => transformInputsToRelativePositions(props.task.content, img), [img, props.task.content]);

  //
  // NB: We defer the mounting of our inputs by 100ms. This allows for smoother
  // transitions while toggling facit, opening/closing Harmonicas etc., as the
  // font-size calculation within the inputs may become expensive due to
  // layout-trashing.
  //
  const isMounting = useActivityIndicator(!inputs$1, {
    delayMs: 0,
    durationMs: 100,
    allowInitial: true
  });
  const renderedImageHeight = dimensions.height ?? backgroundImageMaxHeightInPx;
  const scale = img ? renderedImageHeight / img.naturalHeight : 1;
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-context": context,
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsxs("div", {
      className: canvas,
      children: [/*#__PURE__*/jsx(NoSSR, {
        children: /*#__PURE__*/jsx("div", {
          className: inputs,
          "data-visible": !isMounting.isActive(),
          children: !isMounting.isActive() && inputs$1?.map(input => /*#__PURE__*/jsx(PlaceItemsOnImageDropzone, {
            draggable: props.draggable,
            draggedItemId: props.draggedItemId,
            dropzone: input,
            facitType: props.facitType,
            scale: scale,
            taskEntryKey: props.taskEntryKey,
            tiles: props.task.tiles,
            settings: props.task.settings
          }, input.id))
        })
      }), /*#__PURE__*/jsx(PostloadedImage, {
        ref: imageRef,
        className: background,
        src: props.task.backgroundImageSrc,
        alt: ""
      })]
    })
  });
}

export { Canvas };
//# sourceMappingURL=organism.canvas.js.map
